import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import { forwardRef, useState, useRef, useImperativeHandle } from 'react';
import { useGeneratedId } from '../../../utils/index.js';
import { useAutoHeight } from '../../utils/useAutoHeight/index.js';
import { TextAreaContainer, TextAreaFocusLine, StyledTextArea } from './styled.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Avatar } from '../../dataDisplay/Avatar/components/Avatar.js';
import { AvatarLetter } from '../../dataDisplay/Avatar/components/AvatarLetter.js';

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var ChatInput = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var autoId = useGeneratedId('chatinput');
  var value = props.value,
    userName = props.userName,
    _props$maxHeight = props.maxHeight,
    maxHeight = _props$maxHeight === void 0 ? 146 : _props$maxHeight,
    _props$id = props.id,
    id = _props$id === void 0 ? autoId : _props$id,
    restProps = __rest(props, ["value", "userName", "maxHeight", "id"]);
  var _useState = useState(false),
    hasFocus = _useState[0],
    setHasFocus = _useState[1];
  var textAreaRef = useRef(null);
  useImperativeHandle(forwardedRef, function () {
    return textAreaRef.current;
  });
  useAutoHeight({
    textAreaRef: textAreaRef,
    textAreaValue: value,
    minHeight: 16,
    maxHeight: maxHeight,
    enabled: true
  });
  var handleFocus = function handleFocus(event) {
    setHasFocus(true);
    if (restProps.onFocus) {
      restProps.onFocus(event);
    }
  };
  var handleBlur = function handleBlur(event) {
    setHasFocus(false);
    if (restProps.onBlur) {
      restProps.onBlur(event);
    }
  };
  var textAreaProps = Object.assign(Object.assign({}, restProps), {
    id: id,
    value: value,
    onFocus: handleFocus,
    onBlur: handleBlur,
    ref: textAreaRef
  });
  var avatarProps = {
    solid: true,
    size: 'md',
    shape: 'circle',
    appearance: 'cyan'
  };
  return /*#__PURE__*/jsxs(TextAreaContainer, {
    children: [/*#__PURE__*/jsx(Avatar, _extends({}, avatarProps, {
      children: /*#__PURE__*/jsx(AvatarLetter, {
        children: userName.slice(0, 1)
      })
    })), /*#__PURE__*/jsx(TextAreaFocusLine, {
      $hasFocus: hasFocus
    }), /*#__PURE__*/jsx(StyledTextArea, _extends({}, textAreaProps))]
  });
});

export { ChatInput };
